import { I as Icon, _ as _extends } from './Icon-465858dc.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Close = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M4.9289 4.9286c-.3905.3906-.3905 1.0237 0 1.4143L10.586 12 4.9292 17.657c-.3905.3905-.3905 1.0237 0 1.4142.3905.3905 1.0237.3905 1.4142 0l5.6569-5.6569 5.6565 5.6565c.3905.3905 1.0237.3905 1.4142 0 .3905-.3906.3905-1.0237 0-1.4142l-5.6564-5.6565 5.6568-5.6568c.3905-.3905.3905-1.0237 0-1.4142-.3906-.3906-1.0237-.3906-1.4143 0l-5.6568 5.6568-5.6572-5.6573c-.3905-.3905-1.0237-.3905-1.4142 0z"
    }),
    filledrtl: /*#__PURE__*/React.createElement("path", {
      d: "M4.9289 4.9286c-.3905.3906-.3905 1.0237 0 1.4143L10.586 12 4.9292 17.657c-.3905.3905-.3905 1.0237 0 1.4142.3905.3905 1.0237.3905 1.4142 0l5.6569-5.6569 5.6565 5.6565c.3905.3905 1.0237.3905 1.4142 0 .3905-.3906.3905-1.0237 0-1.4142l-5.6564-5.6565 5.6568-5.6568c.3905-.3905.3905-1.0237 0-1.4142-.3906-.3906-1.0237-.3906-1.4143 0l-5.6568 5.6568-5.6572-5.6573c-.3905-.3905-1.0237-.3905-1.4142 0z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M4.9289 4.9286c-.3905.3906-.3905 1.0237 0 1.4143L10.586 12 4.9292 17.657c-.3905.3905-.3905 1.0237 0 1.4142.3905.3905 1.0237.3905 1.4142 0l5.6569-5.6569 5.6565 5.6565c.3905.3905 1.0237.3905 1.4142 0 .3905-.3906.3905-1.0237 0-1.4142l-5.6564-5.6565 5.6568-5.6568c.3905-.3905.3905-1.0237 0-1.4142-.3906-.3906-1.0237-.3906-1.4143 0l-5.6568 5.6568-5.6572-5.6573c-.3905-.3905-1.0237-.3905-1.4142 0z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Close.displayName = "CloseIcon";

export { Close, Close as default };
